import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  fetchKitchenOrders,
  fetchKitchenOrdersSuccess,
  fetchKitchenOrdersFailure,
  markKitchenOrderServedSuccess,
  markKitchenOrderServedFailure,
} from "./actions";
import { FETCH_KITCHEN_ORDERS, MARK_KITCHEN_ORDER_SERVED } from "./constants";

export function* fetchKitchenOrdersSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, date, service } = payload || {};
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (service) params.set("service", service);
  const query = params.toString() ? `?${params.toString()}` : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location/${id}/meal-orders${query}`,
    );
    const body = data?.data ?? data ?? {};
    yield put(
      fetchKitchenOrdersSuccess({
        date: body.date ?? date,
        service: body.service ?? service,
        menu: body.menu ?? null,
        summary: body.summary ?? null,
        residents: body.residents ?? [],
        locationId: id,
        sittings: Array.isArray(body.sittings)
          ? body.sittings
          : Array.isArray(body.summary?.sittings)
            ? body.summary.sittings
            : null,
      }),
    );
  } catch (e) {
    yield put(fetchKitchenOrdersFailure());
    yield put(errorAlert("Error while loading meal orders."));
  }
}

export function* markKitchenOrderServedSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, date, service, locationId } = payload || {};
  try {
    yield call(api(token).put, `/api/resident/${residentId}/meal-orders`, {
      date,
      service,
      status: "served",
    });
    yield put(markKitchenOrderServedSuccess());
    yield put(successAlert("Marked served."));
    if (locationId) {
      yield put(fetchKitchenOrders({ id: locationId, date, service }));
    }
  } catch (e) {
    yield put(markKitchenOrderServedFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Could not mark this order as served."));
  }
}

export default function* KitchenOrdersSaga() {
  yield all([
    takeEvery(FETCH_KITCHEN_ORDERS, fetchKitchenOrdersSaga),
    takeEvery(MARK_KITCHEN_ORDER_SERVED, markKitchenOrderServedSaga),
  ]);
}
